import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import clientInformation, { setClientItem, getClientItem } from '../login/ClientInfo';
import Alerts from '../helpers/Alerts';
import { IsValidToken } from "../../services/AuthenticationService";
import { GetDepositLimits, GetExpressLimits } from "../../services/DepositService"
import Loading from '../helpers/Loader';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/RegularMethods';

export const RegularMethods = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    const [isLoading, setIsLoading] = useState(true);
    const [arrayDeposits, setArrayDeposits] = useState([]);
    const [disableExpress, setDisableExpress] = useState(false);
    const navigate = useNavigate();
    let HideNavigation = process.env.REACT_APP_HideNavigation;
    const mode = getClientItem('Mode');
    const hideNav = HideNavigation == 'true' || mode === 'Deposit' || mode === 'Withdrawal';
    const [country, setCountry] = useState(getClientItem('CountryCode'));

    useEffect(() => {

        IsValidToken(getClientItem('Token')).then(async function (response) {
            await DepositsLimits();
            await ExpressDepositsLimits();
        }

        ).catch(function (error) {
            navigate('/expired/');
        })

    }, []);

    async function ExpressDepositsLimits() {
        await GetExpressLimits(getClientItem('Token')).then(async function (response) {
            if (response.Authentication.length === 0) {
                setDisableExpress(true);
            }
        });
    }
    console.log(country);
    async function DepositsLimits() {
        await GetDepositLimits(getClientItem('Token')).then(async function (response) {
            var i = 0;
            console.log(response);
            const filtered = response.Authentication.map(item => {

                const {
                    IconURL,
                    DepositName,
                    DepositID,
                    CreditCardTypeID,
                    PaymentType,
                    ImageName,
                    MinDeposit,
                    MaxDeposit,
                    ProcessorID
                } = item;
                if ((item.PaymentType === "Credit Card" ||
                    item.PaymentType === "Crypto" ||
                    item.PaymentType === "P2P" ||
                    item.PaymentType === "Western Union" ||
                    item.PaymentType === "Money Gram" ||
                    item.PaymentType === "RIA" ||
                    item.PaymentType === "Remitly" ||
                    item.PaymentType === "BossRev" ||
                    item.PaymentType === "Check" ||
                    item.PaymentType === "Generic")
                    ||
                    (item.PaymentType === "EWallet"
                        && (item.ImageName === "neteller" ||
                            item.ImageName.toLowerCase() === "paysafecard" ||
                            item.ImageName.toLowerCase() === "paypal" ||
                            item.ImageName.toLowerCase() === "braintree" ||
                            item.ImageName.toLowerCase() === "googlepay" ||
                            item.ImageName.toLowerCase() === "applepay" ||
                            item.ImageName.toLowerCase() === "premieret" ||
                            item.ImageName.toLowerCase() === "premierint" ||
                            item.ImageName.toLowerCase() === "premierplus" ||
                            item.ImageName.toLowerCase() === "pagomovil" ||
                            item.ImageName.toLowerCase() === "wipay" ||
                            item.ImageName.toLowerCase() === "quickervoucher" ||
                            item.ImageName.toLowerCase() === "quickervoucherv2" ||
                            item.ImageName.toLowerCase() === "quickerzelle" ||
                            item.ImageName.toLowerCase() === "apexglobal" ||
                            item.ImageName.toLowerCase() === "marketusa" ||
                            item.ImageName.toLowerCase() === "changelly" ||
                            item.ImageName.toLowerCase() === "moonpay" ||
                            item.ImageName.toLowerCase() === "quickbuy" ||
                            item.ImageName.toLowerCase() === "kribatta" ||
                            item.ImageName.toLowerCase() === "flashteller" ||
                            item.ImageName.toLowerCase() === "fastgateway" ||
                            item.ImageName.toLowerCase() === "majestic" ||
                            item.ImageName.toLowerCase() === "triplewallet" ||
                            item.ImageName.toLowerCase() === "upay" ||
                            item.ImageName.toLowerCase() === "venmo" ||
                            item.ImageName.toLowerCase() === "zelle" ||
                            item.ImageName.toLowerCase() === "onramp-cashapp" ||
                            item.ImageName.toLowerCase() === "alphapaysonramp" ||
                            item.ImageName.toLowerCase() === "onramp-revolut" ||
                            item.ImageName.toLowerCase() === "onramp-paypal" ||
                            item.ImageName.toLowerCase() === "quickerach" ||
                            item.ImageName.toLowerCase() === "tylt" ||
                            item.ImageName.toLowerCase() === "paycash" ||
                            item.ImageName.toLowerCase() === "r4conecta" ||
                            item.ImageName.toLowerCase() === "r4debitoinmediato" ||
                            item.ImageName.toLowerCase() === "clkk"
                        ))) {
                    return {
                        Key: i++,
                        IconURL,
                        DepositName,
                        DepositID,
                        CreditCardTypeID,
                        PaymentType,
                        ImageName,
                        MinDeposit,
                        MaxDeposit,
                        ProcessorID
                    };
                }
            });
            await setArrayDeposits(filtered.filter(function (element) { return element !== undefined; }));
            setIsLoading(false);
        }).catch(function (error) {
            setIsLoading(false);
            clientInfo.Error = false;
            Alerts.ShowAlert(t.error, t.errorGettingLimits + error.response.data.Authentication.ErrorDescription, 'error');
            navigate('/main/');

        })
    }

    function GetFormURL(Key) {
        if (arrayDeposits[Key].PaymentType.toLowerCase() === "credit card")
            return "/deposits/creditcard/" + arrayDeposits[Key].DepositID
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "crypto")
            return "/deposits/crypto/" + arrayDeposits[Key].DepositID
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "p2p")
            return "/deposits/p2p/" + arrayDeposits[Key].DepositID.toLowerCase()
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "ewallet")
            switch (arrayDeposits[Key].ImageName.toLowerCase()) {
                case "quickerzelle":
                case "quickervoucher":
                    {
                        return "/deposits/zelle/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                case "triplewallet":
                    {
                        return "/deposits/dualstep/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                case "quickerach":
                    {
                        return "/deposits/quickerach/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                case "r4conecta":
                    {
                        return "/deposits/r4conecta/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                case "r4debitoinmediato":
                    {
                        return "/deposits/r4debitoinmediato/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                case "paycash":
                    {
                        return "/deposits/paycash/" + arrayDeposits[Key].DepositID;
                        break;
                    }
                default: {

                    return "/deposits/ewallet/" + arrayDeposits[Key].DepositID;
                    break;
                }
            }
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "money gram")
            return "/deposits/p2p/moneygram/"
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "ria")
            return "/deposits/p2p/ria/"
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "remitly")
            return "/deposits/p2p/remitly/"
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "bossrev")
            return "/deposits/p2p/bossrev/"
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "check")
            return "/deposits/check/"
        else if (arrayDeposits[Key].PaymentType.toLowerCase() === "generic")
            return "/deposits/generic/" + arrayDeposits[Key].ProcessorID;
        else
            return "";
    }

    if (isLoading) {
        return <Loading />;
    }

    const handlePayoutSelect = (name) => {
        navigate(`/payouts/${name}`);
    }

    const handleExpressSelect = () => {
        navigate(`/main/`);
    }


    if (arrayDeposits.length === 0) {
        navigate('/main/');
    }

    setClientItem('ArrayRegularMethods', JSON.stringify(arrayDeposits));

    return (
        <div className="mt-3 componentload">
            <div className="row">
                <div className="col-12">
                    <hr />
                </div>
            </div>
            <div className="title">
                <div className="container">
                    <h4 className="txt-primary text-title-color"></h4>
                </div>
            </div>
            <div className="row">
                {hideNav ? <div></div> :
                    disableExpress == false ?
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                            <div onClick={() => handleExpressSelect()} className="box-deposit express-color mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">{t.expressDeposit}</span>
                            </div>
                        </div>
                        :
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6" title={t.expressDisabledTitle}>
                            <div className="box-deposit express-color-disabled mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">{t.expressDeposit}</span>
                            </div>
                        </div>
                }
                {hideNav ? <div></div> :
                    <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                        <div onClick={() => handlePayoutSelect('')} className="box-deposit payoutmethod-color mb-4 text-center text-wrap" >
                            <span className="othermethod-text text-center">{t.withdrawalOptions}</span>
                        </div>
                    </div>
                }
            </div>
            <div className="row">
                {arrayDeposits.map((item) => (
                    <div className="col-xxl-4 col-md-4 col-sm-6 col-xs-6">
                        <Link key={item.Key} to={GetFormURL(item.Key)} className="box-deposit  mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div className="image-wrapper">
                                        <span className="icon-single">
                                            <img
                                                alt=""
                                                src={item.PaymentType.toLowerCase() === 'generic' ? `data:image/svg+xml;base64,${item.ImageName}` : `/svg/${item.ImageName}.svg`}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-12 text-center limit-text">
                                    <span>{t.min}:${item.MinDeposit === 0 ? 1 : item.MinDeposit} - {t.max}:{item.MaxDeposit === 0 ? t.noLimit : '$' + item.MaxDeposit}</span>
                                </div>
                                <div className="col-md-3 limit-text d-none d-md-block ">

                                </div>
                            </div>
                        </Link>
                    </div>
                ))}


            </div>
        </div>
    );
}
